import DSRReportsRouteShell, {
  AuditQueueColumnDef,
  dsrMissingFieldsTemplate,
} from "./DSRReportsRouteShell";

const genentAuditQueueColumns: AuditQueueColumnDef[] = [
  {
    header: "Missing Fields",
    body: dsrMissingFieldsTemplate,
    style: { minWidth: "200px" },
  },
  { field: "ISRC", header: "ISRC", style: { minWidth: "150px" } },
  { field: "Artist", header: "Artist", style: { minWidth: "180px" } },
  { field: "SongTitle", header: "Song Title", style: { minWidth: "180px" } },
  { field: "Label", header: "Label", style: { minWidth: "160px" } },
  { field: "Publisher", header: "Publisher", style: { minWidth: "160px" } },
];

const GenEntReportsRoute = () => {
  return (
    <DSRReportsRouteShell
      reportType="genent"
      title="GenEnt Reports"
      description="Generate and download current GenEnt audit reports from PostClaim-GenEnt table"
      auditQueueColumns={genentAuditQueueColumns}
    />
  );
};

export default GenEntReportsRoute;
